/* globals document */

import React, { Component } from 'react';
import styleable from 'react-styleable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import queryString from 'querystring';
import '../../styles/core.scss';
import css from './students.scss';
import ContentBox from '../../components/content-box/content-box';
import AvailableStudentsFilter from '../../components/available-students-filter/available-students-filter';
import ClassGroupStudents from '../../components/class-group-students/class-group-students';
import ActionButton from '../../components/action-button/action-button';
import { showConfirmation, executeConfirmCommand
} from '../../containers/confirmation-modal/confirmation-modal-actions';
import { moveCopyDisableButton, truncateName } from '../../helpers/utils';
import Text from './students-text';

// import student actions
import { getAllData, moveOrCopyStudents, navigateBtnClick, selectClass, selectGroup, selectSchoolClass,
    selectSchoolGroup, selectSurname, selectYearGroup,
    setupButtons, toggleSelectAllAvailableStudents, navigateToPortalModule,
    toggleSelectAllStudents, unassign, updateAvailableStudentListSelection, updateStudentListSelection, updateTitle
} from './students-actions';


@styleable(css)
class Students extends Component {
    constructor(props) {
        super(props);
        this.showConfirmationButton = false;
    }

    static propTypes = {
        executeConfirmCommand: PropTypes.func,
        getAllData: PropTypes.func,
        history: PropTypes.object,
        location: PropTypes.object,
        moveOrCopyStudents: PropTypes.func,
        navigateBtnClick: PropTypes.func,
        productId: PropTypes.any,
        selectClass: PropTypes.func,
        selectClassGroup: PropTypes.func,
        selectGroup: PropTypes.func,
        selectSchoolClass: PropTypes.func,
        selectSchoolGroup: PropTypes.func,
        selectSurname: PropTypes.func,
        selectYearGroup: PropTypes.func,
        setupButtons: PropTypes.func,
        showConfirmation: PropTypes.func,
        studentsReducer: PropTypes.object,
        toggleSelectAllAvailableStudents: PropTypes.func,
        toggleSelectAllStudents: PropTypes.func,
        unassign: PropTypes.func,
        updateAvailableStudentListSelection: PropTypes.func,
        updateStudentListSelection: PropTypes.func,
        updateTitle: PropTypes.func,
        navigateToPortalModule: PropTypes.func,
        headerInfo: PropTypes.string,
        backUrl: PropTypes.string,
        i18n: PropTypes.object,
        confirmCommandInfo: PropTypes.string
    };

    componentDidMount() {
        const headerInfo = this.props.headerInfo || {
            title: 'Classes',
            subTitle: 'STUDENT MANAGEMENT'
        };
        this.props.updateTitle(headerInfo.title, headerInfo.subTitle);
        const { queryParams, wholeClassId, wholeGroupId } = this.props.studentsReducer;
        const query = this.props.location.search;
        const queryStr = query.replace('?', '');
        let { classId, groupId } = queryString.parse(queryStr);
        if (!classId) { classId = wholeClassId; }
        if (!groupId) { groupId = wholeGroupId; }
        this.props.getAllData(this.props.productId, classId, groupId);

        const leftButtons = [];
        const rightButtons = [
        ];
        if (queryParams.backUrl || queryParams.sourceModuleId) {
            rightButtons.push({
                label: 'Back',
                type: 'OPEN_URL',
                action: () => {
                    if (queryParams.sourceModuleId) {
                        this.props.navigateToPortalModule(queryParams.sourceModuleId, queryParams);
                    } else if (queryParams.backUrl) {
                        window.open(this.props.backUrl, '_self');
                    }
                },
                data: {
                    ...queryParams
                }
            });
        } else if (queryParams.sourceModule) {
            rightButtons.push({
                label: 'Back',
                type: 'BACK_TO_WHOLE_CLASS',
                action: () => {},
                data: {
                    type: queryParams.sourceModule
                }
            });
        }
        this.props.setupButtons(leftButtons, rightButtons);
    }

    componentDidUpdate(prevProps) {
        const { confirmCommandInfo, selectedClassId, selectedGroupId, selectedStudents, availableClassGroupId,
            availableClassId, availableSelectedStudents, availableSurnameId, availableYearGroupId
        } = this.props.studentsReducer;
        const { productId, i18n } = this.props;
        this.showConfirmationButton = false;
        // triggers resource manager with relevant backend call
        if (confirmCommandInfo !== prevProps.confirmCommandInfo) {
            let message = '';
            if (confirmCommandInfo === 'move') {
                message = `${i18n.t`You have moved the selected student(s)`}`;
            } else if (confirmCommandInfo === 'copy') {
                message = `${i18n.t`You have copied the selected student(s)`}`;
            }

            const data = {
                action: confirmCommandInfo,
                students: availableSelectedStudents,
                classId: selectedClassId,
                groupId: selectedGroupId,
                availableClassId,
                availableGroupId: availableClassGroupId,
                surnameGroupId: availableSurnameId,
                yearGroupId: availableYearGroupId,
                productId,
                message
            };
            switch (confirmCommandInfo) {
            case 'back':
                this.props.navigateBtnClick(this.props.history, { toUrl: '/whole-class' });
                break;
            case 'unassign-student':
                this.props.unassign(productId, selectedClassId, selectedGroupId, selectedStudents, {
                    availableClassId,
                    availableGroupId: availableClassGroupId,
                    surnameGroupId: availableSurnameId,
                    yearGroupId: availableYearGroupId
                });
                break;
            case 'move':
                this.props.moveOrCopyStudents(data);
                break;
            case 'copy':
                this.props.moveOrCopyStudents(data);
                break;
            default:
                break;
            }
        }
    }

    displayUnassignConfirmation() {
        const { selectedStudents } = this.props.studentsReducer;
        const { selectedClassId, selectedGroupId, availableClassGroupId,
            availableClassId, availableSurnameId, availableYearGroupId
        } = this.props.studentsReducer;
        const { productId, i18n } = this.props;
        let message = '';
        message = selectedStudents.length > 1 ?
            i18n.t`${selectedStudents.length} students have been removed/unassigned from this class` :
            i18n.t`Student successfully removed/unassigned from this class`;
        this.props.unassign(productId, selectedClassId, selectedGroupId, selectedStudents, {
            availableClassId,
            availableGroupId: availableClassGroupId,
            surnameGroupId: availableSurnameId,
            yearGroupId: availableYearGroupId,
            message
        });
    }

    handleOnRemoveFromClass = () => {
        const { selectedStudents, classGroupStudents } = this.props.studentsReducer;
        if (selectedStudents.length === classGroupStudents.length) {
            this.showConfirmationButton = true;
            this.setState({ showConfirmationButton: this.showConfirmationButton });
        } else this.displayUnassignConfirmation();
    }

    handleOnConfirmButtonCancel = () => {
        this.showConfirmationButton = false;
        this.setState({ showConfirmationButton: this.showConfirmationButton });
    }

    render() {
        const { availableClassGroupId, availableClassGroupStudents, availableClassGroups, availableClassId,
            availableClasses, availableSelectedStudents, availableSurnameId, availableYearGroupId, classGroupStudents,
            classGroups, classList, classroomName, fromWholeClass, selectAllAvailableStudents, selectAllStudents,
            selectedClassId, selectedGroupId, selectedStudents, surnames, yearGroups, queryParams
        } = this.props.studentsReducer;
        const { productId } = this.props;
        const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        return (
            <div className={css.students} >
                {fromWholeClass || typeof this.props.backUrl !== 'undefined' ? <div className={css['title-box']}>
                    {Text.assignedFor} <span className={'text'}>{classroomName}</span>
                </div> : null}
                <ContentBox >
                    <div className={css['row-section-student']}>
                        <div className={css.columns}>
                            <div className={`${css['sub-title']} text`}>
                                {Text.availableStudents}
                            </div>
                            <AvailableStudentsFilter
                                allSelected={selectAllAvailableStudents}
                                classGroupId={availableClassGroupId}
                                classGroups={availableClassGroups}
                                classrooms={availableClasses}
                                selectAll={this.props.toggleSelectAllAvailableStudents}
                                selectClass={this.props.selectSchoolClass}
                                selectClassGroup={this.props.selectClassGroup}
                                selectedClassId={availableClassId}
                                selectGroup={(groupId) => {
                                    this.props.selectSchoolGroup(productId, availableClassId, groupId,
                                        availableSurnameId, availableYearGroupId);
                                }}
                                selectStudents={this.props.updateAvailableStudentListSelection}
                                selectSurname={this.props.selectSurname}
                                selectYearGroup={this.props.selectYearGroup}
                                students={availableClassGroupStudents}
                                surnameId={availableSurnameId}
                                surnames={surnames}
                                yearGroups={yearGroups}
                                yearGroupId={availableYearGroupId}
                                productId={productId}
                            />
                        </div>
                        <ActionButton
                            availableClassId={availableClassId}
                            selectedClassId={selectedClassId}
                            moveCopyDisableButton={() => moveCopyDisableButton(availableSelectedStudents,
                                availableClassId, selectedClassId, availableClassGroupId, selectedGroupId)}
                            showConfirmation={this.props.showConfirmation}
                            executeMoveCommand={() => this.props.executeConfirmCommand('move')}
                            executeCopyCommand={() => this.props.executeConfirmCommand('copy')}
                            isIE11={isIE11}
                        />
                        <div className={css.columns}>
                            {fromWholeClass || typeof this.props.backUrl !== 'undefined' ?
                                <div className={`${css['sub-title']} text`}>
                                    {Text.assigned}
                                    &nbsp;
                                    <span>
                                        {truncateName(classroomName)} (
                                        {classGroupStudents ? classGroupStudents.length : null})
                                    </span>
                                </div> : <div className={`${css['sub-title']} text`}>
                                    {Text.manage}
                                </div>}
                            <ClassGroupStudents
                                allSelected={selectAllStudents}
                                classGroups={classGroups}
                                classId={selectedClassId}
                                classList={classList}
                                groupId={selectedGroupId}
                                selectAll={this.props.toggleSelectAllStudents}
                                selectClass={(classId) => {
                                    this.props.selectClass(productId, classId);
                                }}
                                selectGroup={(groupId) => {
                                    this.props.selectGroup(productId, selectedClassId, groupId);
                                }}
                                selectStudents={this.props.updateStudentListSelection}
                                selectedStudents={selectedStudents}
                                students={classGroupStudents}
                                unassign={() => { this.displayUnassignConfirmation(); }}
                                fromWholeClass={fromWholeClass ||
                                    typeof this.props.backUrl !== 'undefined' ||
                                    typeof queryParams.sourceModuleId !== 'undefined'
                                }
                                productId={productId}
                                handleOnRemoveFromClass={this.handleOnRemoveFromClass}
                                showConfirmationButton={this.showConfirmationButton}
                                handleOnConfirmButtonCancel={this.handleOnConfirmButtonCancel}
                            />
                        </div>
                    </div>
                </ContentBox>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        studentsReducer: state.studentsReducer
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        executeConfirmCommand,
        getAllData,
        moveOrCopyStudents,
        navigateBtnClick,
        selectClass,
        selectGroup,
        selectSchoolClass,
        selectSchoolGroup,
        selectSurname,
        selectYearGroup,
        setupButtons,
        showConfirmation,
        toggleSelectAllAvailableStudents,
        toggleSelectAllStudents,
        unassign,
        updateAvailableStudentListSelection,
        updateStudentListSelection,
        navigateToPortalModule,
        updateTitle
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Students);



// WEBPACK FOOTER //
// ./containers/students/students.js